const SIMPLE = {
  verticalAlignment: "center",
  horizontalAlignment: "center",
  backgroundColor: "transparent",
  borderColor: "transparent",
  borderWidth: 0,
  maxWidth: "medium",
  minHeight: "auto",
  name: "Simple",
  round: "8px",
};

const ARRAY = {
  name: "Array",
  verticalAlignment: "start",
  horizontalAlignment: "center",
  backgroundColor: "transparent",
  borderColor: "transparent",
  borderWidth: 1,
  round: "8px",
  minHeight: "auto",
  maxWidth: "large",
  setsPerLine: "auto",
  setsSpace: "16",
};

const VTIMELINE = {
  name: "VTimeline",
  verticalAlignment: "center",
  horizontalAlignment: "center",
  minHeight: "auto",
  maxWidth: "medium",
  timelineType: "vertical",
  timelineColor: "var(--theme-color-3)",
  timelinePosition: "center",
  timelineStyle: "line",
  timelineMarker: "bullets",
};

const SIDEBYSIDE = {
  backgroundColor: "transparent",
  borderColor: "transparent",
  borderWidth: 1,
  horizontalAlignment: "center",
  maxWidth: "100",
  minHeight: "auto",
  name: "SideBySide",
  round: "8px",
  setsPerLine: "1",
  setsSpace: "16",
  verticalAlignment: "center",
};

const NARRATOR = {
  backgroundColor: "transparent",
  horizontalAlignment: "center",
  layout: "left",
  name: "Narrator",
  stepBackgroundColor: "var(--background-main-color)",
  stepBorderWidth: "1",
  style: "side-by-side",
  verticalAlignment: "center",
};

const TABS = {
  name: "Tabs",
  verticalAlignment: "center",
  horizontalAlignment: "start",
  backgroundColor: "transparent",
  borderColor: "transparent",
  borderWidth: 1,
  round: "8px",
  maxWidth: "large",
  tabsDesign: "design-3",
  tabsLayout: "top",
  tabsPerRow: "auto",
  tabsBorderRadius: "50px",
  tabsFontSize: "16",
  isShowTabsIcons: false,
  tabsAutoplay: false,
  tabsLoop: false,
  tabsSpeed: "medium",
  tabsDelay: "10",
  tabsColor: "var(--paragraph-color)",
  tabsHoverColor: "var(--button-text-hover-color)",
  tabsBgColor: "var(--background-secondary-color)",
  tabsBgHoverColor: "var(--button-background-hover-color)",
};

const FULLSCREEN = {
  maxWidth: "100",
  verticalAlignment: "center",
  horizontalAlignment: "center",
  backgroundColor: "var(--theme-color-1)",
  borderColor: "transparent",
  backgroundType: "none",
  minHeight: "auto",
  groupsRatio: ["50", "50"],
  name: "FullScreen",
};

const CAROUSEL = {
  name: "Carousel",
  horizontalAlignment: "center",
  backgroundColor: "transparent",
  maxWidth: "medium",
  carouselBulletsColorActive: "var(--theme-color-1)",
  carouselBulletsOpacityActive: 100,
  carouselBulletsColor: "var(--theme-color-1)",
  carouselBulletsOpacity: 50,
  carouselContainer: "stacked",
  carouselStyle: "regular",
  carouselAnimationType: "slide-in",
  carouselAutoplayActive: true,
  carouselAutoplaySpeed: "medium",
};

export const DEFAULT_COMBO_SETTINGS = {
  SIMPLE,
  ARRAY,
  VTIMELINE,
  SIDEBYSIDE,
  NARRATOR,
  TABS,
  CAROUSEL,
  FULLSCREEN,
} as const;
